var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"talk_parent_1"},[_c('div',{staticClass:"talk_div_1"},[_vm._v(_vm._s(_vm.text))]),_c('div',{staticClass:"triangle_border_left_1"})])}
var staticRenderFns = []

export { render, staticRenderFns }